import { useUserSettings } from 'hooks'
import { useCallback, useMemo } from 'react'

const useFitterRelativeTimeInfo = (date: Date, customer_timezone: string, fitter_timezone: string | null) => {
  const { locale } = useUserSettings()

  const fitterTimeFormatter = useMemo(
    () =>
      fitter_timezone
        ? new Intl.DateTimeFormat(locale, {
            hour: 'numeric',
            minute: '2-digit',
            hourCycle: 'h12',
            timeZone: fitter_timezone,
          })
        : undefined,
    [fitter_timezone, locale]
  )
  return useCallback(() => {
    if (!fitter_timezone) {
      return { fitterTime: null, isDayAfter: false, isDayBefore: false }
    }

    const [fitterYear, fitterMonth, fitterDay] = new Intl.DateTimeFormat('sv', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      timeZone: fitter_timezone,
    })
      .format(date)
      .split('-')

    const [customerYear, customerMonth, customerDay] = new Intl.DateTimeFormat('sv', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      timeZone: customer_timezone,
    })
      .format(date)
      .split('-')

    const fitterTime = fitterTimeFormatter?.format(date)?.toLowerCase()
    const fitterSum = Number(`${fitterYear}${fitterMonth}${fitterDay}`)
    const customerSum = Number(`${customerYear}${customerMonth}${customerDay}`)

    return {
      fitterTime,
      isDayAfter: fitterSum > customerSum,
      isDayBefore: fitterSum < customerSum,
    }
  }, [date, fitter_timezone, fitterTimeFormatter])
}

export { useFitterRelativeTimeInfo }
